import {
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpEvent,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { StateService } from '../../services/state.service';
import { ApiConfiguration } from '../../api/api-configuration';
import { NoTokenPaths } from '../constants/no-token-paths';

@Injectable()
export class AuthenticationInterceptor implements HttpInterceptor {
  constructor(private apiCfg: ApiConfiguration, private state: StateService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let sendAccessToken = false;
    let withCreds = true;

    if (
      req.url
        .toLowerCase()
        .startsWith(`${this.apiCfg.rootUrl}/api/`.toLowerCase())
    ) {
      sendAccessToken = true;
    }
    NoTokenPaths.forEach((x) => {
      if (
        req.url
          .toLowerCase()
          .startsWith(`${this.apiCfg.rootUrl}${x}`.toLowerCase())
      ) {
        sendAccessToken = false;
      }
    });

    if (sendAccessToken) {
      const headers = req.headers.set(
        'Authorization',
        `Bearer ${this.state.accessToken}`
      );
      req = req.clone({ headers, withCredentials: withCreds });
    } else {
      req = req.clone({ withCredentials: withCreds });
    }

    return next.handle(req);
  }
}
